let announcement_bar = {
    init() {
        const ab_date_container = document.querySelectorAll('.promo-banner__date');

        ab_date_container.forEach(function (item) {
            let ab_enddate = item.querySelector('.promo-banner__end-date').innerText;
            let ab_daysleft = item.querySelector('.promo-banner__days-left');

            if(item.classList.contains('force-midnight')) {
                ab_enddate = new Date();
                ab_enddate.setHours(24,0,0,0);
            };

            // Set the date we're counting down to
            let countDownDate = announcement_bar.parseDate(ab_enddate);

            if (Number.isNaN(countDownDate.getTime())) {
                ab_daysleft.innerHTML = expiredMessage;
                return;
            }

            // Update the count down every 1 second
            let x = setInterval(function () {

                // Get today's date and time
                let now = announcement_bar.californiaTime();

                // Find the distance between now and the count down date
                let distance = countDownDate.getTime() - now.getTime();
                // Time calculations for days, hours, minutes and seconds
                let days = Math.floor(distance / (1000 * 60 * 60 * 24));
                let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                let minutes = Math.ceil((distance % (1000 * 60 * 60)) / (1000 * 60));
                let seconds = Math.floor((distance % (1000 * 60)) / 1000);

                // Display the result in the element with id="demo"
                ab_daysleft.innerHTML = days + "d " + hours + "h "
                    + minutes + "m " + seconds + "s ";

                // If the count down is finished, write some text
                if (distance < 0) {
                    clearInterval(x);
                    ab_daysleft.innerHTML = expiredMessage;
                }
            }, 1000);
        });
    },
    parseDate(date) {
        if (date instanceof Date) {
            return date;
        }

        const rawDate = String(date || '').trim();

        if (!rawDate) {
            return new Date(NaN);
        }

        // Support Japanese-formatted dates like "2026年3月28日 09:00:00".
        const japaneseMatch = rawDate.match(
            /^(\d{4})\s*年\s*(\d{1,2})\s*月\s*(\d{1,2})\s*日(?:\s+(\d{1,2})(?::(\d{1,2}))?(?::(\d{1,2}))?)?$/
        );

        if (japaneseMatch) {
            const [, year, month, day, hours = '0', minutes = '0', seconds = '0'] = japaneseMatch;
            return new Date(
                Number(year),
                Number(month) - 1,
                Number(day),
                Number(hours),
                Number(minutes),
                Number(seconds)
            );
        }

        return new Date(rawDate);
    },
    californiaTime(date = null) {
        let dt = (date == null) ? new Date() : new Date(date);
        return new Date(dt.toLocaleString('en-US', { timeZone: 'America/Los_Angeles' }));
    }
}

document.addEventListener("DOMContentLoaded", function () {
    announcement_bar.init();
});
